var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"doTEXTAXIS"},[_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.cont.stem))]),_c('Timeline',_vm._l((JSON.parse(_vm.cont.metas)),function(v){return _c('TimelineItem',{key:v,staticClass:"content-li"},[_c('div',[_vm._v(" "+_vm._s(v))])])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }